import labels from "../../../../config/labels";
import {
  CustomContainer,
} from "../../../atoms/DependencyHelper";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import styles from "./OrderHistoryLoadMore.module.scss";
import IconEndOfTheList from "../../../../public/assets/images/end-of-list.svg";

const OrderHistoryLoadMore = ({totalPages, pageNumber, pageInfo, onLoadMore, buttonLabel}) => {

  const reachedEnd = totalPages === pageNumber;

  return (
    <CustomContainer className={styles["order-load-more"]}>
      {!reachedEnd ? (<span className="p-4">
          <CTAButton
            variant="outline black"
            handleClick={(event) =>
              onLoadMore(event, pageInfo)
            }
            className={`${styles["order-load-more--btn"]} mb-xs btn-outline-dark`}
            id={`load-more-btn`}
          >
            <label>{buttonLabel || labels.lbl_load_more_orders}</label>
          </CTAButton>
     </span>) : (<>
        <span className="pt-5">
          <IconEndOfTheList className={styles["order-load-list-end"]} />
        </span>
        <span className={styles["order-load-more--label"]}>{labels.lbl_end_order_list}</span>
      </>)}
    </CustomContainer>
  );
}

export default OrderHistoryLoadMore;
